import { useEffect, useState } from 'react';
import { transfersAPI } from '@matix/api-client';

/**
 * Transfer requests waiting to be RECEIVED at this branch's store — the
 * sidebar badge. One cheap count on a slow timer, same reasoning as the
 * call-centre badge: the sidebar is mounted on every till all day. Silent on
 * failure; a badge is not worth a toast.
 */
export function usePendingTransferCount(enabled: boolean): number {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return;
    }
    let alive = true;
    const run = (): void => {
      void transfersAPI
        .pendingCount()
        .then((r) => {
          if (alive) setCount(r.incoming);
        })
        .catch(() => undefined);
    };
    run();
    const id = setInterval(run, 60_000);
    const onFocus = (): void => run();
    window.addEventListener('focus', onFocus);
    return () => {
      alive = false;
      clearInterval(id);
      window.removeEventListener('focus', onFocus);
    };
  }, [enabled]);
  return count;
}
